site.height = {
	maxHeight: function (selector) {
		if (!selector || $(selector).length === 0) return;
		$(window).load(function() {
			site.height.setMaxHeight(selector);
		});
		$(window).resize(function () {
			site.height.setMaxHeight(selector);
		});
	},

	setMaxHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},

	equalHeight: function (selector) {
		if (!selector || $(selector).length === 0) return;
		$.fn.minHeight = function(){
			return this.css('min-height',Math.max.apply(this, $.map( this , function(e){ return $(e).outerHeight() })));
		};

		$(window).load(function() {
			$(selector).removeAttr('style').minHeight();
		});
		$(window).resize(function () {
			$(selector).removeAttr('style').minHeight();
		});
	}
};
